export function propCheck(store, localStorage, propertyPreference) {
  //prop oriented check
  if (!store.state.utilitySettings || store.state.utilitySettings.isPropertyOriented != true)
    return;

  //no account it store
  if (!store.getters.getSelectedAccount.account) {
    //get account from local storage
    let savedProp, temp = localStorage.get('_property');
    if (temp && temp.length > 0) {
      savedProp = JSON.parse(temp);
    }

    //acount exist
    if (savedProp && savedProp.account && savedProp.account.account == propertyPreference.accountCode) 
      store.commit('setSelectedAccount', savedProp);
    else
      this.$router.push('userHome');
  }
}
